module.exports = __webpack_public_path__ + "static/media/complexPic7.e6bec244.png";